import * as React from 'react';
import { default as _Map } from './components/map';
import { default as _Marker } from './components/marker';
import { default as _Popup } from './components/popup';
import { default as _AttributionControl } from './components/attribution-control';
import { default as _FullscreenControl } from './components/fullscreen-control';
import { default as _GeolocateControl } from './components/geolocate-control';
import { default as _NavigationControl } from './components/navigation-control';
import { default as _ScaleControl } from './components/scale-control';
import { useMap as _useMap } from './components/use-map';
export function useMap() {
  return _useMap();
}
var mapLib = import('!mapbox-gl');
export var Map = (() => {
  return React.forwardRef(function Map(props, ref) {
    return _Map(props, ref, mapLib);
  });
})();
export var Marker = _Marker;
export var Popup = _Popup;
export var AttributionControl = _AttributionControl;
export var FullscreenControl = _FullscreenControl;
export var NavigationControl = _NavigationControl;
export var GeolocateControl = _GeolocateControl;
export var ScaleControl = _ScaleControl;
export { default as Source } from './components/source';
export { default as Layer } from './components/layer';
export { default as useControl } from './components/use-control';
export { MapProvider } from './components/use-map';
export default Map; // Types

export * from './types/public';